/**
 * RTK Query cache tags for different API domains
 */
export const API_TAGS = {
  AUTH: 'Auth',
  LAYOUT: 'Layout',

  DASHBOARD: 'Dashboard',
  STORAGE: 'Storage',
  TRANSPORT: 'Transport',
  SERVICE_USERS: 'ServiceUsers',
  MAPPING: 'Mapping',
  OPTIONS: 'Options'
} as const;

export type ApiTag = (typeof API_TAGS)[keyof typeof API_TAGS];
